const SrmDebugConstants = {
  SET_PARTIAL_CONTEXT: "srmDebug/SET_PARTIAL_CONTEXT",
  SET_CONTEXT: "srmDebug/SET_CONTEXT",
  SEGMENT_AGGREGATE: "**NONE**",
  SRM_THRESHOLD: 5e-4,
  SRM_COLOR: "#fed9cc",
  NO_SRM_COLOR: "#edebe9",
  GREATER_THAN_OR_EQUAL: "≥",
  LESS_THAN_OR_EQUAL: "≤",
  Event_ShowHideInterim: "ShowHideInterim",
  Event_ChangeSRMThreshold: "ChangeSRMThreshold",
  Event_FllterPrimarySegment: "FllterPrimarySegment",
  Event_CreateDRITicket: "CreateDRITicket",
  Event_AnswerFollowUpQuestion: "AnswerFollowUpQuestion",
  Event_MarkAsResolved: "MarkAsResolved",
  Event_TryNextCheck: "TryNextCheck",
  Event_StartResolving: "StartResolving",
  Event_LinkToStandardScorecard: "LinkToStandardScorecard",
  Event_LinkToTriggeredScorecard: "LinkToTriggeredScorecard",
  Event_LinkToMultidayScorecard: "LinkToMultidayScorecard",
  Event_LinkToSegmentScorecard: "LinkToSegmentScorecard",
  Event_PivotToPage: "Event_PivotToPage",
  Section_TriggeredCheck: "TriggeredCheck",
  Section_Summary: "Summary",
  Section_MultidayCheck: "MultidayCheck",
  Section_SegmentsCheck: "SegmentsCheck",
  Section_DRITicket: "DRITicket"
};
export {
  SrmDebugConstants as default
};
//# sourceMappingURL=SrmDebugConstants.js.map
